module.exports = __webpack_public_path__ + "media/country_flags/tn-3898ca4e.png";